import ACTIONS from "../constants/actions";

const {
  GET_ALL_PAYROLL_REQUEST,
  GET_ALL_PAYROLL_SUCCESS,
  GET_ALL_PAYROLL_FAIL,
  GET_PAYROLL_DETAIL_REQUEST,
  GET_PAYROLL_DETAIL_SUCCESS,
  GET_PAYROLL_DETAIL_FAIL,
} = ACTIONS;

const initialState = {
  allPayroll: [],
  payrollDetail: null,
  isLoadingPayroll: false,
  isLoadingPayrollDetail: false,
};

const loginPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_PAYROLL_REQUEST:
      return {
        ...state,
        isLoadingPayroll: true,
      };
    case GET_ALL_PAYROLL_SUCCESS:
      return {
        ...state,
        allPayroll: action.payload,
        isLoadingPayroll: false,
      };
    case GET_ALL_PAYROLL_FAIL:
      return {
        ...state,
        isLoadingPayroll: false,
      };

    case GET_PAYROLL_DETAIL_REQUEST:
      return {
        ...state,
        isLoadingPayrollDetail: true,
      };
    case GET_PAYROLL_DETAIL_SUCCESS:
      return {
        ...state,
        payrollDetail: action.payload,
        isLoadingPayrollDetail: false,
      };
    case GET_PAYROLL_DETAIL_FAIL:
      return {
        ...state,
        isLoadingPayrollDetail: false,
      };
    default:
      return state;
  }
};
export default loginPageReducer;
